// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Cookies from 'js-cookie';
import Element from 'element-ui';

import '@/styles/index.scss'; // global css
import './styles/element-variables.scss';
import App from './App';
import router from './router';
import i18n from './lang';
import './icons'; // icon
import store from './store';

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value),
});
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js